import { Box, Typography } from '@mui/material'
import React from 'react'
import Grid from '@mui/material/Grid2';
import { ReactFitty } from 'react-fitty';
import img1 from '../../assets/img/workExpPage/img1.png'
import img2 from '../../assets/img/workExpPage/img2.png'
import img3 from '../../assets/img/workExpPage/img3.png'

const WorkExp = () => {
  return (
    <Box height={"100dvh"}>
      <Grid
        container
        spacing={0}
        sx={{
          borderBottom: '4px solid #e5e8d9',
          backgroundColor: '#191b1e',
          zIndex: 2,
          position: 'relative',
          overflow: 'hidden',
          height: '80%',
          '@media screen and (max-width: 1200px)': {
            padding: '10px',
            marginTop: '0px',
            height: '90%',
            '& div': {
              height: '30%'
            },
            '& img': {
              width: '100%'
            }
          }
        }}
      >
        <Grid size={{ xs: 12, md: 12, lg: 4 }} sx={{ height: '100%' }}>
          <img src={img1} alt="exmpl-img" style={{ height: '100%' }} />
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 4 }} sx={{ height: '100%' }}>
          <img src={img2} alt="exmpl-img" style={{ height: '100%' }} />
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 4 }} sx={{ height: '100%' }}>
          <img src={img3} alt="exmpl-img" style={{ height: '100%' }} />
        </Grid>
      </Grid>
      <Box sx={{
        padding: '100px',
        height: '20%',
        marginTop: '-75px',
        '@media screen and (max-width: 600px)': {
          height: '10%',
          padding: '10px',
          marginTop: '0px',
        }
      }}>
        <Typography
          color='primary'
          sx={{
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
            lineHeight: 0.7,
            marginTop: "-45px",
            '@media screen and (max-width: 600px)': {
              // fontSize: '1.3rem'
            }
          }}
          component={ReactFitty}
        >
          WORK EXPERIENS
        </Typography>
      </Box>
    </Box>
  )
}

export default WorkExp